import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=main-walking&exp=web_walking_models_from_creos~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_walking_models_from_creos'
					),
			},
			funnel: {
				id: 'ob-walking-models-from-creos',
				locale: ['en'],
			},
		},
	},
]

export default config
